import React from 'react';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-dayjs-4';


interface DataType {count: number, time: string, label: string};

export type BarChartProps = {
  data?: DataType[];
  chartHeight?: number;
  startTime: number;
  endTime: number;
  events?: {time: string, count: number, label?: string}[];
  width?: number;
};

export function BarChart(props: BarChartProps) {
  
  const id = React.useMemo(() => Math.random().toString(), []);

  React.useLayoutEffect(() => {
    const element = document.getElementById(id);
    if(!props.data?.length || !element) return;
    renderChart(
      props.data,
      element,
      props.startTime,
      props.endTime,
      props.events
    )
  }, [id, props.data, props.events]);

  return (
    <div className={'w-full chart-wrapper'}>
      <div style={{ width: props.width || '600px'}}><canvas id={id}></canvas></div>
    </div>
  );
};

function renderChart(
  data: DataType[],
  element: HTMLElement,
  startTime: number,
  endTime: number,
  events?: {time: string, count: number, label?: string}[]
) {

  const datasetMap: {[label: string]: Array<DataType>} = {};

  for(let item of data) {
    const label = item.label || 'default';
    if(!datasetMap[label]) datasetMap[label] = [];
    datasetMap[label].push(item);
  }

  const datasetKeys = Object.keys(datasetMap);
  const datasets = datasetKeys.map((key, index) => {
    const data = datasetMap[key];
    return {
      label: key,
      backgroundColor: colors[index],
      data: data.map(row => ({ x: new Date(row.time), y: row.count })),
      stack: `Stack 0`,
    }
  });

  if(events?.length) {
    datasets.push({
      type: 'scatter',
      data: events.map(row => ({ x: new Date(row.time), y: 0 })),
      elements: {
        point: {
          radius: 5
        },
      },
    } as any)
  }

  let chart: Chart<any> = element['_chart'] as Chart;

  if(chart) {
    chart.data.datasets = datasets;
    chart.update();
    return;
  }

  chart = new Chart(
    element as any,
    {
      type: 'bar',
      data: {
        // labels: data.map(row => new Date(row.time)),
        datasets: datasets
      },
      options: {
        elements: {
          line: {
            borderColor: (ctx) => colors[ctx.datasetIndex],
            borderWidth: 1,
          },
          point: {
            radius: 0
          },
        },

        
        parsing: {
          xAxisKey: 'x',
          yAxisKey: 'y'
        },
        scales: {
          x: {
            type: 'time',
            min: startTime || undefined,
            max: endTime || undefined,
            ticks: {
              autoSkip: false,
              maxRotation: 0,
              major: {
                enabled: true
              },
              // color: function(context) {
              //   return context.tick && context.tick.major ? '#FF0000' : 'rgba(0,0,0,0.1)';
              // },
              font: function(context) {
                if (context.tick && context.tick.major) {
                  return {
                    weight: 'bold',
                  };
                }
              }
            },
            // time: {
            //   unit: 'second',
            //   tooltipFormat: 'DD HH::mm',
            // },
            stacked: true,
            grid: {
              display: false
            }
          },
          y: {
            title: {
              display: true,
              text: 'Sessions'
            },
            stacked: true,
          }
        }
      }
    }
  );

  element['_chart'] = chart;
}


const colors = ['red', 'green', 'blue', 'yellow'];